import React, { FC } from 'react';
import { ListItem } from '@cubeyou-team/hx-react-components';

import translations from 'src/lang';

import { MoreActions } from '../more-actions';
import {
  PANEL_VIEWS,
  useStanleyQueryPanel,
} from '../../providers/StanleyQueryPanelContext';

const { STANLEY_QUERY: translation } = translations['en-US'];

export const StanleyQueryMoreActions: FC = () => {
  const { handleNewQuery, setView, setSelectedHistoryRunId } =
    useStanleyQueryPanel();

  return (
    <MoreActions
      items={(closeDropdown) => [
        <ListItem
          key="history"
          text={translation.MODAL.HISTORY.MENU}
          iconLeft="query_temp"
          onClick={() => {
            setSelectedHistoryRunId(null);
            setView(PANEL_VIEWS.HISTORY);
            closeDropdown();
          }}
        />,
        <ListItem
          key="new-query"
          text={translation.BUTTON.NEW_QUERY}
          iconLeft="icon-add"
          onClick={() => {
            handleNewQuery();
            closeDropdown();
          }}
        />,
      ]}
    />
  );
};
